import {InstrumentComponent} from "./InstrumentComponent.js";
import {DialIndicatorComponent} from "./DialIndicatorComponent.js";
import {getAverageVote} from '@megaphonenpm/mputils/src/utils.js';
import {MegaScreen} from "../MegaScreen.js";
import {hide, setText, show} from '@megaphonenpm/mputils/src/DOM.js';

export class AnswersMoodMeterComponent extends InstrumentComponent {
  constructor (themeID) {
    super(themeID, 'moodmeter', new DialIndicatorComponent(themeID));
  }

  build () {
    super.build();

    // Pre-flight check
    if (!this.valid) {
      return;
    }
    this.view.append(this.valueLabel.view);
    this.view.style.flexWrap = 'nowrap';

    if (this.direction === 'vertical') {
      // Force the value label to appear below the dial
      this.view.style.flexDirection = 'column';
    }

    setText(this.valueLabel.view.querySelectorAll(`.${this.instrumentName}_value_label_title_txt`),
      this.getLocaleString('audience_average'));
  }

  updateAverageVote () {
    super.updateAverageVote();
    if (!this.valid) {
      return;
    }
    // TODO: Remove redundancy with superclass's retrieval of average vote
    let averageAsPercentage = getAverageVote(MegaScreen.globals.appState.votes);
    this.valueLabel.setValue(averageAsPercentage);
  }

  resetAverageVote () {
    super.resetAverageVote();
    if (!this.valid) {
      return;
    }

    this.valueLabel.setValue(0);
  }

  startSceneResult () {
    super.startSceneResult();
    if (!this.valid) {
      return;
    }

    hide(this.valueLabel.view);
  }

  reset () {
    super.reset();
    if (!this.valid) {
      return;
    }

    show(this.valueLabel.view);
  }
}